<template>
  <div>
    <div
      :style="{
        background:
          goods.fullReductionInfo && goods.fullReductionInfo.activityType === 2001
            ? '#fff4f0'
            : goods.signed === 1
              ? 'rgba(248,252,255,1)'
              : 'none',
      }"
    >
      <!-- 参与活动 -->
      <div
        v-if="
          goods.fullReductionInfo &&
            goods.fullReductionInfo.activityType === 2001 &&
            goods.showActivity
        "
        class="activity-wrap clearfix"
      >
        <span
          class="activity-wrap_tip fl"
        ><SingleTag :show="true" :datas="{name: TLang('满减','list')}" /></span>
        <span class="activity-wrap_content fl">
          <span v-if="goods.signed === 1">
            <!-- 优惠金额设置膨胀比 -->
            <span
              v-if="goods.fullReductionInfo.current"
            >
              {{ ReplaceText(
                'YY',
                parseFloat((goods.fullReductionInfo.current.full * union_scale).toFixed(2)),
                ReplaceText(
                  'XX',
                  parseFloat((goods.fullReductionInfo.current.reduction * union_scale).toFixed(2)),
                  TLang('已享满减', 'list')
                )
              )}}
            </span>
            <span
              v-if="
                goods.fullReductionInfo.current &&
                  goods.fullReductionInfo.buyAgain
              "
            >,</span>
            <!-- 优惠金额设置膨胀比 -->
            <span
              v-if="goods.fullReductionInfo.buyAgain"
            >{{ ReplaceText(
              'ZZ',
              parseFloat((goods.fullReductionInfo.buyAgain * union_scale).toFixed(2)),
              ReplaceText(
                'JJ',
                parseFloat((goods.fullReductionInfo.next.reduction * union_scale).toFixed(2)),
                ReplaceText(
                  'MM',
                  parseFloat((goods.fullReductionInfo.next.full * union_scale).toFixed(2)),
                  TLang('再买享满', 'list')
                )
              ))
            }}
            </span>
          </span>
          <span v-else>{{ TLang('参加满减活动','list') }}</span>
        </span>
        <span
          class="activity-wrap_link fl"
          @click="goSearch"
        >{{ TLang('去凑单','list') }}</span>
      </div>
      <!-- -->
      <el-row
        :class="{
          'goods-item': true,
          'activity-item':
            goods.fullReductionInfo &&
            goods.fullReductionInfo.activityType === 2001,
        }"
      >
        <el-col
          :span="3"
          class="flex dis-text"
        >
          <span v-if="invalide" :style="{ padding:'0 4px' }">{{ TLang('失效','list') }}</span>
          <div
            v-else
            class="flex"
            @click="onSignChange(goods)"
          >
            <div
              v-if="goods.signed"
              class="checked"
            >
              <i class="el-icon-check"></i>
            </div>
            <div v-else>
              <i class="not-check"></i>
            </div>
          </div>
          <!-- <div class="goods-img-wrap">
            <img
              :src="goods.imgGuide"
              class="goods-img"
              alt
              @click="gotoDetail(goods)"
            />
            <Sticker :imgList="goods.stickerImgList" />
          </div> -->
          <div
            class="goods-img-wrap"
            @click="gotoDetail(goods)"
            :style="{marginLeft:  invalide? '0':'12px'}"
          >
            <img
              :src="goods.imgGuide"
              class="goods-img"
              alt
            />
            <img class="soldOut" :src="require('@assets/images/allGone.png')" alt v-if="goods.bizStock === 0" />
            <Sticker :imgList="goods.stickerImgList" />
          </div>
        </el-col>
        <el-col
          :span="4"
          class="goods-name"
        >
          <h4>
            <i
              :style="{ fontStyle: 'normal'}"
            >
              <SingleTag :show="goods.cartGoodsType == 2" :datas="{name: TLang('奖品', 'list')}" :putName="'PrizeGoods'" />
            </i>
            <i
              v-for="(tag, index) in goods.tags"
              :key="index"
              :style="{ fontStyle: 'normal'}"
            >
              <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
            </i>
            {{ goods.goodsName }}
          </h4>
          <span>{{ TLang('商品编码','list') }}{{ goods.spuCode || "JD_3349900" }}</span>
          <span class="discountDesc" v-if="goods.totalLimit != null">{{ disCountDesc }}</span>
          <h6 v-if="invalide">
            {{ goods.notBuy }}
          </h6>
          <div
            v-if="goods.preSale || !!goods.preSaleDesc"
            class="presell-info"
          >
            <!-- <i>{{union_isBilingual ? 'Pre-sale':'预售'}}</i> -->
            <img
              :src="
                union_isBilingual || CookiesOne && CookiesOne == 'en-US'
                  ? require('./../../../../assets/images/order/presale.png')
                  : require('./../../../../assets/images/order/pre-sell-ch.png')
              "
            />
            <h6 v-if="goods.preSaleDesc">
              {{goods.preSaleDesc}}
            </h6>
            <h6 v-else>
              {{ ReplaceText('sss', transformDate(goods.sendGoodsTimeStart), ReplaceText('eee', transformDate(goods.sendGoodsTimeEnd) , TLang('presaleOrder', 'list'))) }}
            </h6>
          </div>
          <div
            v-if="hasMktInfo(goods)"
            class="presell-info market-info"
          >
            <!-- <img :src="goods.mktSkuDetail[0].mktIcon" v-if="goods.mktSkuDetail[0].mktIcon" /> -->
            <span v-if="goods.mktSkuDetail && goods.mktSkuDetail.length > 0">
              <span
                v-if="goods.mktSkuDetail[0].mktIcon"
                :style="{marginTop: 0, lineHeight: '16px !important'}"
              >
                <SingleTag :show="true" :datas="goods.mktSkuDetail[0]" />
              </span>
              <!-- "mktFrontType":"前台促销类型，1001：单一特价，1002：单一折扣，1003：单一直降，1004：抢购，300001：抽奖", -->
              <h6 v-if="goods.mktSkuDetail[0].mktFrontType === 1004">
                {{ ReplaceText('XXXX', goods.showMarketTime, TLang('还剩活动结束', 'list')) }}
              </h6>
              <h6 v-if="goods.mktSkuDetail[0].mktFrontType === 1001">
                {{ ReplaceText('XXXX', goods.showMarketTime, TLang('还剩恢复原价', 'list')) }}
              </h6>
            </span>
            <!-- PC暂不展示抽奖 -->
            <!-- <span
              v-if="goods.participationPrize == 1"
              :style="{marginTop: 0, lineHeight: '16px !important'}"
            >
              <SingleTag :show="true" :datas="{name: TLang('抽奖', 'list')}" />
            </span> -->
          </div>
        </el-col>
        <el-col
          :span="5"
          :style="{ paddingLeft: '50px', color: '#999999' }"
        >
          <span
            :class="
              goods.goodsSpecList &&
                goods.goodsSpecList.length > 1 &&
                (!goods.cartGoodsType || goods.cartGoodsType != 2) &&
                'selectable'
            "
            @mouseenter="popVisible = true"
            @mouseleave="popVisible = false"
          >
            {{ TLang('规格','orderConfirm') }}：{{ goods.specValue1 }}
            <!-- 商品有多规格且该商品非奖品（cartGoodsType：2），可切换规格 -->
            <i
              v-if="goods.goodsSpecList && goods.goodsSpecList.length > 1 && (!goods.cartGoodsType || goods.cartGoodsType != 2)"
              class="icon iconfont"
            >&#xe647;</i>
            <PopoverSpec
              v-if="goods.goodsId"
              :visible="popVisible"
              :goodsSpecList="goods.goodsSpecList || []"
              :defaultGoods="goods"
              :handleSkuChange="updateSpecGoods"
              :onCancle="
                () => {
                  popVisible = false;
                }
              "
            />
          </span>
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          <div>
            {{ ((goods.discountPrice || goods.promPrice || goods.price) * union_scale).toFixed(2) }}
          </div>
          <div v-if="promGoods && promGoods.length > 0">
            <span class="line-price-box">
              <img
                :src="union_icon || defaultLineIcon"
                alt=""
                class="fudou2"
                style="filter: grayscale(1);"
                v-if="!union_strikethroughPriceIcon"
              />
              <img
                :src="union_strikethroughPriceIcon"
                alt=""
                class="fudou2"
                v-if="union_strikethroughPriceIcon"
              />
              <span class="line-price-num">
                {{(goods.originalPrice || goods.price) * union_scale}}
              </span>
            </span>
          </div>
          <DiscountPrice 
            :discountPrice="goods.discountPrice"
            :discount="goods.discount"
            :discountTagShow="goods.discountTagShow"
            :mktTagShow="goods.mktTagShow"
            tipType="cart"
            :isShowPrice="false"
            :price="goods.promPrice || goods.price || 0"
          />
            <el-tooltip
              :content="tipContent"
              placement="bottom-end"
              v-if="goods.goodsServiceFeeRate"
            >
              <span class="line-service">
                {{ TLang('需平台服务费','my') }}{{goods.goodsServiceFeeRate}}
                <img src="@assets/images/tips_bg.png"/>
              </span>
            </el-tooltip>
        </el-col>
        <el-col
          v-if="invalide || (goods.cartGoodsType && goods.cartGoodsType == 2)"
          :span="3"
          align="center"
        >
          {{
            goods.num
          }}
        </el-col>
        <el-col
          v-else
          :span="3"
          align="center"
          class="step-shopping"
        >
          <Stepper
            v-if="goods.num"
            :onChange="handleStepperChange.bind(this, goods)"
            :buyLimit="goods.buyLimit"
            :buyMin="goods.buyMin"
            :stockNum="goods.stockNum"
            :defaultValue="goods.num"
            :isCart="true"
          />
        </el-col>
        <el-col
          :span="3"
          align="center"
        >
          {{ ((goods.totalAmount || 0) * union_scale).toFixed(2) }}
        </el-col>
        <el-col
          :span="3"
          align="center"
          class="delete-btn"
        >
          <span @click="showDelPop">{{ TLang('删除','address') }}</span>
          <div
            v-show="deletePopVisible"
            :class="['confirm-del', goods.cartGoodsType > 0 && goods.cartGoodsType == 2 ? 'comfirm-del-prize' : '']"
          >
            <p>
              <span
                :style="{ verticalAlign: 'middle' }"
              ><svg
                t="1582171266704"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="8524"
                width="16"
                height="16"
              >
                <path
                  d="M512 512m-409.6 0a409.6 409.6 0 1 0 819.2 0 409.6 409.6 0 1 0-819.2 0Z"
                  fill="#F44545"
                  p-id="8525"
                ></path>
                <path
                  d="M549.24 700.723v45.76c0 20.545-16.684 37.236-37.235 37.236-20.552 0-37.237-16.69-37.237-37.236v-45.76c0-20.545 16.685-37.236 37.237-37.236 20.55 0 37.236 16.69 37.236 37.236z m-73.974-154.65V276.108c0-20.545 16.674-37.237 37.262-37.237 20.55 0 37.211 16.692 37.211 37.237v269.963c0 20.583-16.66 37.237-37.211 37.237-20.588 0-37.262-16.654-37.262-37.237z"
                  fill="#FFFFFF"
                  p-id="8526"
                ></path></svg></span>
              <span>{{ goods.cartGoodsType > 0 && goods.cartGoodsType == 2 ? TLang('删除即视为放弃该奖品','list') : TLang('是否删除该商品','list') }}</span>
            </p>
            <div class="btns">
              <div
                class="confirmDel"
                @click="onClickDel(goods)"
              >
                {{ TLang('删除','address') }}
              </div>
              <div
                class="cancle"
                @click="deletePopVisible = false"
              >
                {{ TLang('取消','address') }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PopoverSpec from './../Popover';
import Stepper from './../../../product/detail/StepperRow';
import Sticker from '@components/sticker';
import SingleTag from '@components/singleTag';
import { gioClickHandle } from '@utils';
import Cookies from 'js-cookie';
import DiscountPrice from './../../../lifeIndex/DiscountPrice';
import { unionFlag } from '@utils';
export default {
  components: {
    PopoverSpec,
    Stepper,
    Sticker,
    DiscountPrice,
    SingleTag,
  },
  props: {
    goods: Object,
    isFreeShip: Number,
    onCheckoutSpec: Function,
    onUpdateCount: Function,
    onSignChange: Function,
    onDelGoods: Function,
    isBFD: Boolean,
    invalide: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      defaultIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_h5.png',
      defaultLineIcon: 'https://fecdn.dongfangfuli.com/mall/images/mallIcon/icon_fudou_delete_h5.png',
      popVisible: false,
      union: unionFlag(),
      deletePopVisible: false,
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  created() {
    if (this.goods.mktSkuDetail && this.goods.mktSkuDetail.length > 0) {
      this.countTime(this.goods.mktSkuDetail[0].endTime);
    }
  },
  // mounted() {
  //   if(this.goods.mktSkuDetail && this.goods.mktSkuDetail.length >0 ){
  //     this.countTime(this.goods.mktSkuDetail[0].endTime)
  //   }
  // },
  computed:{
    // 特价抢购
    promGoods(){
      if(this.goods.mktSkuDetail && this.goods.mktSkuDetail.length >0){
        return this.goods.mktSkuDetail.filter(item => item.mktFrontType == 1001 || item.mktFrontType == 1004);
      }
      return [];
    },
    disCountDesc(){
      if(this.goods.totalLimit != null){
        // 剩余可购买数
        const canBuyNum = (this.goods.totalLimit || 0) - (this.goods.saleNum || 0);
        if(canBuyNum <= 0){
          return TLang('此商品专享价可购剩余数为将以非专享价进行结算','list');
        }
        if(this.goods.num > canBuyNum){
          return `${TLang('此商品购买数量超过专享价可购数','list')} ${canBuyNum}，${TLang('将以非专享价进行结算','list')}`;
        }
        return '';
      }
      return '';
    },
    tipContent() {
      return <div style={{width:'200px', display:'flex'}}>
        {TLang('服务费不计入包邮或满减门槛，以上门槛基于商品实际金额计算','my')}
      </div>
    }
  },
  methods: {
    updateSpecGoods(newGoods, oldGoods) {
      this.popVisible = false;
      if (newGoods.goodsId !== oldGoods.goodsId) {
        this.onCheckoutSpec(newGoods, oldGoods);
      }
    },
    handleStepperChange(goods, val) {
      this.onUpdateCount(goods, val);
    },
    onClickDel(goods) {
      this.deletePopVisible = false;
      this.onDelGoods(goods);
    },
    showDelPop() {
      this.deletePopVisible = true;
    },
    gotoDetail(goods) {
      if(goods.bookId && this.isBFD) {
        const hrefOrigin = {
          test: 'https://exchange.test05.dongfangfuli.com',
          stage: 'http://exchange.stage.dongfangfuli.com',
          pro: 'https://exchange.dongfangfuli.com',
        }
        let linkUrl = hrefOrigin.test;
        let origin = window.location.origin;
        if (origin.indexOf("localhost") > -1) {
          linkUrl = hrefOrigin.test
        } else if (window.df_sdk_common.env.isTest()) {
          linkUrl = hrefOrigin.test
        } else if (window.df_sdk_common.env.isStage()) {
          linkUrl = hrefOrigin.stage;
        } else {
          linkUrl = hrefOrigin.pro;
        }
        window.df_sdk_common.location.href = linkUrl+`/bfd_gift_pc/productDetail?goodsId=${goods.goodsId}&categoryId=${goods.categoryId}&bookId=${goods.bookId}&union=${this.union}`
      } else {
        this.$router.push(
          `/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
        );
      }
    },
    // 已经修改打开新窗口
    goSearch() {
      this.changeGio('满减凑单','去凑单');
      setTimeout(() => {
        window.open('/health/search?keywords=满减&productType=优选生活', this.isFeishuOrDingding ? '_self' : '_blank')
        // window.location.href =
        // '/health/search?keywords=满减&productType=优选生活';
      }, 10);
    },
    changeGio(df_modulename, df_elementname) {
      try {
        let channel = '';
        const params = {
          df_channle: channel,
          df_modulename: df_modulename,
          df_elementname: df_elementname,
        };
        gioClickHandle('DF_elementClick', params, 'cart');
      } catch (e) {
        console.log('埋点失败:', e);
      }
    },
    transformDate(time) {
      if (time) {
        let date = new Date(time);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = month < 10 ? '0' + month : month;
        day = day < 10 ? '0' + day : day;
        return month + TLang('倒计时月', 'orderConfirm') + day + TLang('倒计时日', 'orderConfirm');
      }
    },
    countTime(time) {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();

      let endDate = new Date(time);
      let end = endDate.getTime();
      //时间差
      let differTime = end - now;
      let showTime = '';

      let count = parseInt(differTime / 1000);
      let clearTimer = setInterval(() => {
        if (!count) {
          clearInterval(clearTimer);
          window.location.reload();
        }
        let d = parseInt(count / 60 / 60 / 24, 10);
        let h = parseInt((count / 60 / 60) % 24, 10);
        let m = parseInt((count / 60) % 60, 10);
        let s = parseInt(count % 60, 10);
        d = d < 10 ? '0' + d : d;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;

        showTime = (d > 0 ? d + this.TLang('倒计时天', 'orderConfirm') : '') + h + ':' + m + ':' + s;
        this.goods.showMarketTime = showTime;
        console.log(showTime, this.goods.showMarketTime);
        count--;
      }, 999);
    },
    hasMktInfo(goods) {
      let flag = false;
      if (goods.mktSkuDetail && goods.mktSkuDetail.length > 0 || goods.participationPrize == 1) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>

<style lang="less" scoped>
.activity-wrap {
  color: #f75e35;
  padding: 12px 45px;
  line-height: 16px;
  font-size: 12px;

  &_tip {
    margin-right: 9px;
  }
  &_content {
    margin-right: 40px;
    line-height: 16px;
  }
  &_link {
    cursor: pointer;
    padding-right: 12px;
    background: url("../../../../assets/images/manJianRight.png") right center
      no-repeat;
    background-size: auto 12px;
  }
}
.goods-item {
  padding: 15px 0 16px;
  .goods-img-wrap {
    position: relative;
    margin-left: 12px;
    /deep/.sticker-wrap img {
      width: 90px;
      border: 1px solid rgba(240, 240, 240, 1);
    }
    .soldOut{
      width: 53%;
      height: 53%;
      position: absolute;
      top: 23.5%;
      left: 23.5%;
      z-index: 10
    }
  }
  .goods-img {
    width: 90px;
    height: 90px;
    border: 1px solid rgba(240, 240, 240, 1);
  }
  is-text {
    span {
      display: inline-block;
      width: 32px;
      height: 24px;
      background: rgba(247, 247, 247, 1);
      border-radius: 10px;
      font-size: 12px;
      font-weight: 500;
      color: rgba(178, 178, 178, 1);
      line-height: 24px;
      text-align: center;
      margin-left: 6px;
    }
  }
  .delete-btn {
    cursor: pointer;
    position: relative;
    .confirm-del {
      position: absolute;
      width: 192px;
      height: 112px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
      z-index: 666;
      padding: 24px;
      box-sizing: border-box;
      right: 32px;
      .btns {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        .confirmDel {
          width: 64px;
          height: 24px;
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );
          border-radius: 2px;
          color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(255, 255, 255, 1);
        }
        .cancle {
          width: 64px;
          height: 24px;
          border-radius: 2px;
          border: 1px solid rgba(229, 229, 229, 1);
          color: rgba(153, 153, 153, 1);
          margin-left: 16px;
        }
      }
    }
    .comfirm-del-prize {
      width: 220px;
    }
  }
  .goods-name {
    h4 {
      font-size: 14px;
      color: rgba(17, 17, 17, 1);
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    h6 {
      font-size: 14px;
      color: #111;
    }
    span {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
      margin-top: 5px;
      display: inline-block;
      line-height: 24px;
    }
    .discountDesc{
      white-space: nowrap;
      color: #F75E35;
    }
    .presell-info {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 12px;
      i {
        background: rgba(227, 242, 255, 1);
        border-radius: 4px;
        padding: 0 3px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(61, 150, 226, 1);
        white-space: nowrap;
      }
      img {
        // width: 36px;
        // height: 20px;
        width: 34px;
        height: 16px;
        vertical-align: middle;
        margin-left: 0;
      }
      h6 {
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
        margin-left: 8px;
        white-space: nowrap;
        line-height: 22px;
        font-weight: 400;
      }
    }
    .market-info {
      margin-top: 4px;
      h6 {
        color: #f75e35;
        line-height: 23px;
      
      }
    }
  }
  .step-shopping {
    /deep/ .stepper {
      flex-wrap: wrap;
      align-items: center;
      // justify-content: center;
      .count {
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #fff;
      }
      input {
        height: 24px;
        line-height: 24px;
      }
      // i {
      //   line-height: 20px;
      //   margin-top: 5px;
      //   margin-left: 30px;
      // }
    }
  }
  .selectable {
    position: relative;
    display: inline-block;
    // height: 30px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // max-width: 240px;

    &:hover {
      cursor: pointer;
      color: #3d96e2;
    }
    // &:hover .popover {
    //   display: block;
    // }
    &::after {
      content: "";
      // width: 110%;
      width: 100%;
      display: inline-block;
      height: 1px;
      background: #ccc;
      bottom: 6px;
      position: absolute;
      left: 0;
    }
    &:hover:after {
      background: #3d96e2;
    }
  }
}
.activity-item {
  padding: 0 0 16px;
}
.line-price-box {
  margin-top: 5px;
  position: relative;
  .fudou2 {
    width: 15px;
    height: 15px;
    margin: 0;
    vertical-align: middle;
    // -webkit-filter: grayscale(100%);
    // -moz-filter: grayscale(100%);
    // -ms-filter: grayscale(100%);
    // -o-filter: grayscale(100%);
    // filter: grayscale(100%);
    // filter: gray;
    // opacity: 0.7;
  }
  .line-price-num {
    font-size: 12px;
    margin-left: -4px;
    color: #999999;
    text-decoration: line-through;
  }
  // &:after {
  //   content: "";
  //   width: 103%;
  //   height: 1px;
  //   position: absolute;
  //   left: -1px;
  //   top: 9px;
  //   background-color: #999999;
  // }
}
.line-service {
    display: flex;
    color:#999999;
    font-size: 12px;
    img {
      width: 16px;
      height: 16px;
    }
}
</style>
